var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWeatherHeavySnow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 19.968 19.968"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  d: "M19.968 9v1.968h-4.176l3.24 3.24-1.416 1.44-4.632-4.68h-2.016v2.016l4.68 4.632-1.44 1.416-3.24-3.24v4.176H9v-4.176l-3.24 3.24-1.44-1.416L9 12.984v-2.016H6.984l-4.632 4.68-1.416-1.44 3.24-3.24H0V9h4.176L.936 5.76l1.416-1.44L6.984 9H9V6.984L4.32 2.352 5.76.936 9 4.176V0h1.968v4.176l3.24-3.24 1.44 1.416-4.68 4.632V9h2.016l4.632-4.68 1.416 1.44L15.792 9z",
  clipRule: "evenodd"
})));
export default SvgWeatherHeavySnow;